<template>
  <div class="pa-6">
    <div class="font-18 font-w-600 mb-3">
      <v-icon color="#338A68">
        mdi-chart-arc
      </v-icon>
      Shipment Control (export)
    </div>

    <v-card
      class=" pa-6"
      flat
      style="border: 1px solid #C4C4C4; border-radius: 0px;"
    >
      <v-row>
        <!-- Customer -->
        <v-col cols="3">
          <v-layout class="mb-3">
            <v-flex class="xs3 text-end pt-3 font-12 pr-2 font-weight-bold">
              Customer :
            </v-flex>
            <v-flex class="xs9">
              <v-autocomplete
                min-height="37px"
                append-icon="mdi-chevron-down"
                menu-props="offsetY"
                color="#98CA54"
                outlined
                dense
                class="gray"
                :items="customers"
                v-model="filter.customer_id"
                hide-details
                placeholder="Customer"
                item-text="customer_code"
                item-value="customer_id"
                clearable
                multiple
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-col>

        <!--  CY Date : -->
        <v-col cols="3">
          <v-layout class="align-center mb-3">
            <v-flex class="xs3 text-end font-12 pr-3 font-weight-bold">
              CY Date/<br />Relase Date :
            </v-flex>
            <v-flex class="xs4 px-0">
              <DatePicker
                placeholder="DD/MM/YY"
                hideDetails
                hideDetail
                rulse="fieldRequire"
                :model="date.cy_date_start"
                :max="filter.cy_date_end"
                @update-data="updateDate('cy_date_start', $event)"
              ></DatePicker>
            </v-flex>
            <v-flex class="xs1 text-end font-12 pr-1 font-weight-bold">
              To :
            </v-flex>
            <v-flex class=" xs4">
              <DatePicker
                placeholder="DD/MM/YY"
                hideDetails
                hideDetail
                rulse="fieldRequire"
                :model="date.cy_date_end"
                :min="filter.cy_date_start"
                @update-data="updateDate('cy_date_end', $event)"
              ></DatePicker>
            </v-flex>
          </v-layout>
        </v-col>

        <!--Closing Date -->
        <v-col cols="3">
          <v-layout class="align-center mb-3">
            <v-flex class="xs3 text-end font-12 pr-3 font-weight-bold">
              Closing Date :
            </v-flex>
            <v-flex class="xs4 px-0">
              <DatePicker
                placeholder="DD/MM/YY"
                hideDetails
                hideDetail
                rulse="fieldRequire"
                :model="date.closing_date_start"
                :max="filter.closing_date_end"
                @update-data="updateDate('closing_date_start', $event)"
              ></DatePicker>
            </v-flex>
            <v-flex class="xs1 text-end font-12 pr-1 font-weight-bold">
              To :
            </v-flex>
            <v-flex class=" xs4">
              <DatePicker
                placeholder="DD/MM/YY"
                hideDetails
                hideDetail
                rulse="fieldRequire"
                :model="date.closing_date_end"
                :min="filter.closing_date_start"
                @update-data="updateDate('closing_date_end', $event)"
              ></DatePicker>
            </v-flex>
          </v-layout>
        </v-col>
        <v-col cols="3"></v-col>
      </v-row>

      <v-row>
        <!-- Importer -->
        <v-col cols="3">
          <v-layout class="align-center mb-3">
            <v-flex class="xs3 text-end font-12 pr-2 font-weight-bold">
              Importer <br />
              /Exporter :
            </v-flex>
            <v-flex class="xs9">
              <v-autocomplete
                height="37px"
                append-icon="mdi-chevron-down"
                menu-props="offsetY"
                color="#98CA54"
                outlined
                dense
                class="gray"
                :items="importerList"
                v-model="filter.importer_exporter_id"
                hide-details
                placeholder=" Importer/Exporter"
                item-text="customer_code"
                item-value="customer_id"
                clearable
                multiple
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-col>

        <!-- Load  Unload Date -->
        <v-col cols="3">
          <v-layout class="align-center mb-3">
            <v-flex class="xs3 text-end font-12 pr-3 font-weight-bold">
              Load/ <br />
              Unload Date :
            </v-flex>
            <v-flex class="xs4 px-0">
              <DatePicker
                placeholder="DD/MM/YY"
                hideDetails
                hideDetail
                rulse="fieldRequire"
                :model="date.unload_date_start"
                :max="filter.unload_date_end"
                @update-data="updateDate('unload_date_start', $event)"
              ></DatePicker>
            </v-flex>
            <v-flex class="xs1 text-end font-12 pr-1 font-weight-bold">
              To :
            </v-flex>
            <v-flex class=" xs4">
              <DatePicker
                placeholder="DD/MM/YY"
                hideDetails
                hideDetail
                rulse="fieldRequire"
                :model="date.unload_date_end"
                :min="filter.unload_date_start"
                @update-data="updateDate('unload_date_end', $event)"
              ></DatePicker>
            </v-flex>
          </v-layout>
        </v-col>

        <!-- Vendor -->
        <v-col cols="3">
          <v-layout class="align-center mb-3">
            <v-flex class="xs3 text-end font-12 pr-2 font-weight-bold">
              Vendor :
            </v-flex>
            <v-flex class="xs9">
              <v-autocomplete
                height="37px"
                append-icon="mdi-chevron-down"
                menu-props="offsetY"
                color="#98CA54"
                outlined
                dense
                class="gray"
                :items="carriers"
                v-model="filter.carrier_id"
                hide-details
                placeholder="Carrier"
                item-text="name"
                item-value="carrier_id"
                clearable
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-col>

        <!-- Driver : -->
        <v-col cols="3">
          <v-layout class="align-center mb-3">
            <v-flex class="xs3 text-end font-12 pr-2 font-weight-bold">
              Driver :
            </v-flex>
            <v-flex class="xs9">
              <v-autocomplete
                height="37px"
                append-icon="mdi-chevron-down"
                menu-props="offsetY"
                color="#98CA54"
                outlined
                dense
                class="gray"
                :items="drivers"
                v-model="filter.driver_id"
                hide-details
                placeholder="Driver"
                item-text="full_name"
                item-value="driver_id"
                clearable
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-col>
      </v-row>
    </v-card>

    <v-card
      width="100%"
      outlined
      class="mt-4"
      flat
      style="border: 1px solid #C4C4C4; border-radius: 0px;"
    >
      <v-layout justify-space-between>
        <v-flex shrink>
          <v-layout class="align-center text-end pl-6">
            <v-flex shrink class=" font-weight-bold">Mode : </v-flex>
            <v-flex shrink pl-6>
              <v-layout>
                <v-flex shrink mr-4>
                  <v-checkbox
                    color="#338A68"
                    v-model="is_export"
                    label="Export"
                  ></v-checkbox>
                </v-flex>
                <v-flex shrink mr-4>
                  <v-checkbox
                    color="#338A68"
                    v-model="is_empty"
                    label="Empty"
                  ></v-checkbox>
                </v-flex>
                <v-flex shrink mr-4>
                  <v-checkbox
                    color="#338A68"
                    v-model="is_laden"
                    label="Laden"
                  ></v-checkbox>
                </v-flex>
                <v-flex shrink mr-4>
                  <v-checkbox
                    color="#338A68"
                    v-model="is_drop_load"
                    label="Drop Load"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex shrink class="text-end pr-6">
          <v-btn
            depressed
            color="#F7D25D"
            class="my-4 font-weight-bold"
            @click="onSearch(1)"
          >
            <v-icon class="mr-3">mdi-magnify</v-icon>
            <span class="text-capitalize">Search</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <div>
      <v-btn
        outlined
        depressed
        color="#338A68"
        dark
        class="shrink my-4 font-weight-bold mr-3"
        @click="exportExcel()"
      >
        <img
          width="20"
          src="../../../assets/images/menu-icons/excel.png"
          alt=""
        />
        <span class="ml-2 shrink text-capitalize">Export Excel </span>
      </v-btn>
    </div>

    <v-layout
      justify-center
      style="box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);"
      wrap
      class="pa-6"
    >
      <v-flex
        xs12
        class="font-16 font-w-600 text-center"
        style="color: #828282"
      >
        Closing Time
      </v-flex>
      <v-flex xs12>
        <v-layout class="mt-2">
          <v-spacer></v-spacer>
          <v-flex shrink class="d-flex align-center mx-2">
            <div
              style="width: 25px; height: 10px; background-color: #EB5757"
            ></div>
            <span class="font-10 ml-1">ภายใน 12 ชม.</span>
          </v-flex>
          <v-flex shrink class="d-flex align-center mx-2">
            <div
              style="width: 25px; height: 10px; background-color: #6296E3"
            ></div>
            <span class="font-10 ml-1">ภายใน 24 ชม.</span>
          </v-flex>
          <v-flex shrink class="d-flex align-center mx-2">
            <div
              style="width: 25px; height: 10px; background-color: #D8D8D8"
            ></div>
            <span class="font-10 ml-1">ภายใน 36 ชม.</span>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <apexchart
          ref="chart"
          width="100%"
          height="500"
          type="bar"
          :options="options"
          :series="series"
        ></apexchart>
      </v-flex>
    </v-layout>

    <div class="mt-6">
      <!-- <v-layout align-center justify-center class=" search">
        <v-flex class=" title font-weight-bold">{{ table_title }}</v-flex>
        <v-spacer></v-spacer>
        <v-flex xs4 class="d-flex ">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="Search"
            outlined
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout> -->

      <div class="table-order mt-4" style="width: 100%">
        <v-data-table :headers="headers" :items="desserts" :search="search">
          <template v-slot:item.closing_date="{ item }">
            <div v-if="item.closing_date" class="text-center">
              <div>
                {{ item.closing_date | moment("DD/MM/YYYY") }}
              </div>
            </div>
            <div v-else>
              --
            </div>
          </template>

          <template v-slot:item.closing_time="{ item }">
            <div v-if="item.closing_time" class="text-center">
              <div>
                {{ convertTime(item.closing_time) }}
              </div>
            </div>
            <div v-else>
              --
            </div>
          </template>
        </v-data-table>
      </div>
    </div>

    <Loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false"
    />
  </div>
</template>

<script>
import ControlTower from "../../../services/api/ControlTower.Service";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import XLSX from "xlsx"; // import xlsx;
import moment from "moment";
import DatePicker from "../../../components/picker/DatePicker.vue";

export default {
  components: {
    Loading,
    DatePicker,
  },
  data() {
    return {
      dialogTable: false,
      isLoading: false,
      is_export: false,
      is_empty: false,
      is_laden: false,
      is_drop_load: false,

      // Table
      search: "",
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "no",
        },
        {
          text: "Job No.",
          align: "start",
          sortable: false,
          value: "order_id",
          width: "150px",
        },
        {
          text: "Customer",
          align: "start",
          sortable: false,
          value: "customer_name",
          width: "150px",
        },
        {
          text: "Exporter",
          align: "start",
          sortable: false,
          value: "exporter_name",
          width: "150px",
        },
        {
          text: "Inv./PO.",
          align: "start",
          sortable: false,
          value: "inv_po",
          width: "100px",
        },
        {
          text: "Booking",
          align: "start",
          sortable: false,
          value: "booking_no",
          width: "100px",
        },

        {
          text: "Qty",
          align: "center",
          sortable: false,
          value: "qty",
          width: "50px",
        },
        {
          text: "Size",
          align: "center",
          sortable: false,
          value: "container_size_name",
          width: "50px",
        },
        {
          text: "Type",
          align: "center",
          sortable: false,
          value: "container_isotype_name",
          width: "50px",
        },
        {
          text: "Vendor",
          align: "start",
          sortable: false,
          value: "carrier_name",
          width: "200px",
        },
        {
          text: "Driver",
          align: "start",
          sortable: false,
          value: "driver_name",
          width: "120px",
        },
        {
          text: "ทะเบียนรถ",
          align: "center",
          sortable: false,
          value: "truck_license_id",
          width: "120px",
        },
        {
          text: "CY Place",
          align: "start",
          sortable: false,
          value: "cy_place_name",
          width: "200px",
        },
        {
          text: "เลขที่ตู้",
          align: "start",
          sortable: false,
          value: "pickup_container_no",
          width: "200px",
        },
        {
          text: "W/H Factory 1",
          align: "start",
          sortable: false,
          value: "wh_factory_name",
          width: "200px",
        },
        {
          text: "Return Place",
          align: "start",
          sortable: false,
          value: "return_place_name",
          width: "200px",
        },
        {
          text: "Closing Date",
          align: "center",
          sortable: false,
          value: "closing_date",
          width: "120px",
        },
        {
          text: "Closing Time",
          align: "center",
          sortable: false,
          value: "closing_time",
          width: "120px",
        },
      ],
      desserts: [],

      series: [],
      options: {
        chart: {
          type: "bar",
          height: 650,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: function(event, chartContext, config) {
              this.showDetail(
                config.w.config.xaxis.categories[config.dataPointIndex]
              );
            }.bind(this),
          },
        },
        title: {
          text: "",
          position: "top",
          align: "center",
          style: {
            fontSize: "20px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#828282",
          },
        },
        legend: {
          show: false,
        },
        plotOptions: {
          bar: {
            height: "100%",
            borderRadius: 4,
            columnWidth: "10%",
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        stroke: {
          width: 2,
          colors: ["#fff"],
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: "14px",
            colors: ["#fff"],
          },
        },
        xaxis: {
          categories: [],
        },
        colors: ["#1ab394"],
      },

      orders: [],
      customers: [],
      importerList: [],
      carriers: [],
      drivers: [],
      filter: {
        mode: [],
        customer_id: [],
        cy_date_start: "",
        cy_date_end: "",
        closing_date_start: "",
        closing_date_end: "",
        importer_exporter_id: [],
        unload_date_start: "",
        unload_date_end: "",
        carrier_id: "",
        driver_id: "",
      },
      date: {
        unload_date_start: "",
        unload_date_end: "",
        cy_date_start: "",
        cy_date_end: "",
        closing_date_start: "",
        closing_date_end: "",
      },
      dataExcel: [],
      table_title: "",
    };
  },
  watch: {
    is_import: {
      handler: function(val) {
        if (val) {
          if (this.filter.mode.indexOf("Import") === -1) {
            this.filter.mode.push("Import");
          }
        } else {
          this.filter.mode.splice(this.filter.mode.indexOf("Import"), 1);
        }
      },
    },
    is_export: {
      handler: function(val) {
        if (val) {
          if (this.filter.mode.indexOf("Export") === -1) {
            this.filter.mode.push("Export");
          }
        } else {
          this.filter.mode.splice(this.filter.mode.indexOf("Export"), 1);
        }
      },
    },
    is_empty: {
      handler: function(val) {
        if (val) {
          if (this.filter.mode.indexOf("Empty") === -1) {
            this.filter.mode.push("Empty");
          }
        } else {
          this.filter.mode.splice(this.filter.mode.indexOf("Empty"), 1);
        }
      },
    },
    is_laden: {
      handler: function(val) {
        if (val) {
          if (this.filter.mode.indexOf("Laden") === -1) {
            this.filter.mode.push("Laden");
          }
        } else {
          this.filter.mode.splice(this.filter.mode.indexOf("Laden"), 1);
        }
      },
    },
    is_drop_load: {
      handler: function(val) {
        if (val) {
          if (this.filter.mode.indexOf("Drop Load") === -1) {
            this.filter.mode.push("Drop Load");
          }
        } else {
          this.filter.mode.splice(this.filter.mode.indexOf("Drop Load"), 1);
        }
      },
    },
  },
  created() {
    this.isLoading = true;
    Promise.all([
      this.getShipmentControlFilter(),
      this.getShipmentControlExport(),
      this.getMasterData(),
    ]).then((res) => {
      if (res.length > 0) {
        this.customers = res[0].customers;
        this.carriers = res[0].carriers;
        this.drivers = res[0].drivers;
        // if (res[1].data.length > 0) {
        //   this.orders = res[1].data.orders;
        //   this.$refs.chart.updateSeries(res[1].data.graph.datasets);
        //   this.$refs.chart.updateOptions({
        //     xaxis: {
        //       categories: res[1].data.graph.labels,
        //     },
        //     colors: res[1].data.graph.backgroundColor,
        //   });
        // }
      }
      this.isLoading = false;
    });
  },
  methods: {
    async getShipmentControlFilter() {
      const res = await ControlTower.getShipmentControlFilter();
      return res;
    },
    async getShipmentControlExport() {
      const res = await ControlTower.getShipmentControlExport(this.filter);
      if (res.data) {
        this.orders = res.data.orders;
        this.$refs.chart.updateSeries(res.data.graph.datasets);
        this.$refs.chart.updateOptions({
          xaxis: {
            categories: res.data.graph.labels,
          },
          colors: res.data.graph.backgroundColor,
        });
      }
      return res;
    },

    onSearch() {
      this.isLoading = true;
      this.getShipmentControlExport(this.filter).then((res) => {
        if (res.data) {
          this.orders = res.data.orders;
          this.$refs.chart.updateSeries(res.data.graph.datasets);
          this.$refs.chart.updateOptions({
            xaxis: {
              categories: res.data.graph.labels,
            },
            colors: res.data.graph.backgroundColor,
          });
        } else {
          this.orders = [];
          this.$refs.chart.updateSeries([]);
          this.$refs.chart.updateOptions({});
        }
        this.isLoading = false;
      });
    },

    async getMasterData() {
      const table = ["importer"];
      const res = await this.$store.dispatch(
        "master_data/getMasterData",
        table
      );
      this.importerList = res.data[0].importer;
      return res.data;
    },

    showDetail(seriesIndex) {
      this.desserts = [];
      this.dataExcel = [];
      this.table_title = seriesIndex;
      this.isLoading = true;
      for (var key in this.orders) {
        if (key == seriesIndex) {
          this.desserts = this.orders[key];
          break;
        }
      }
      if (this.desserts.length > 0) {
        // map data to table format
        this.desserts = this.desserts.map((item, i) => {
          return {
            no: i + 1,
            order_id: item.accept_tender.tender.order_detail.order.order_id,
            customer_name:
              item.accept_tender.tender.order_detail.order.customer_name,
            exporter_name:
              item.accept_tender.tender.order_detail.order.exporter_name,
            inv_po: item.accept_tender.tender.order_detail.order.inv_po,
            booking_no: item.accept_tender.tender.order_detail.order.booking_no,
            qty: item.accept_tender.tender.order_detail.qty > 0 ? 1 : 0,
            container_size_name:
              item.accept_tender.tender.order_detail.container_size_name,
            container_isotype_name:
              item.accept_tender.tender.order_detail.container_isotype_name,
            carrier_name: item.accept_tender.tender.carrier_name,
            driver_name: item.accept_tender.driver_name,
            truck_license_id: item.accept_tender.truck_license_id,
            cy_place_name: item.accept_tender.tender.order_detail.cy_place_name,
            pickup_container_no: item.pickup_container_no,
            wh_factory_name:
              item.accept_tender.tender.order_detail.wh_factory_1_name,
            load_unload_date_time:
              item.accept_tender.tender.order_detail.unload_load_date1 +
              " " +
              item.accept_tender.tender.order_detail.unload_load_time1,
            return_place_name:
              item.accept_tender.tender.order_detail.order.return_place_name,
            closing_date:
              item.accept_tender.tender.order_detail.order.closing_date,
            closing_time:
              item.accept_tender.tender.order_detail.order.closing_time,
          };
        });

        this.setDataExcel(this.desserts);
        this.dialogTable = true;
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    updateDate(name, val) {
      this.filter[name] = val ? val : "";
      this.date[name] = val ? this.customDate(val) : "";
    },

    customDate(val) {
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },

    convertTime(time) {
      return time.slice(0, -3);
    },

    exportExcel() {
      if (this.dataExcel.length === 0) {
        this.$swal.fire({
          title: "Something went wrong!",
          text: "Please, Choose Data",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        });
      } else {
        this.$swal
          .fire({
            title: "Are you sure?",
            text: `Do you want to export Order to Excel?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Export!",
          })
          .then((result) => {
            if (result.isConfirmed) {
              const dataWS = XLSX.utils.json_to_sheet(this.dataExcel);
              const wb = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(wb, dataWS);
              const fileName = `ShipmentControlExport_${moment(
                new Date()
              ).format("DD_MM_YYYY_h_mm_ss")}.xlsx`;
              XLSX.writeFile(wb, fileName);
            }
          });
      }
    },

    setDataExcel(items) {
      items.forEach((data) => {
        this.dataExcel.push({
          No: data.no,
          "Job No.": data.order_id,
          Customer: data.customer_name,
          Exporter: data.importer_name
            ? data.importer_name
            : data.exporter_name,
          "Inv./PO.": data.inv_po,
          Booking: data.booking_no,
          Qty: data.qty,
          "Container Size": data.container_size_name,
          "Container Type": data.container_isotype_name,
          Vendor: data.carrier_name,
          Driver: data.driver_name,
          ทะเบียนรถ: data.truck_license_id,
          "CY Place": data.cy_place_name,
          เลขที่ตู้: data.pickup_container_no,
          "W/H Factory 1": data.wh_factory_name,
          "Return Place": data.return_place_name,
          "Closing Date": data.closing_date,
          "Closing Time": data.closing_time,
        });
      });
    },
  },
};
</script>

<style></style>
